/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Swarmind API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ModelsModel } from '../models';
// @ts-ignore
import { RestErrResponse } from '../models';
/**
 * ModelsApi - axios parameter creator
 * @export
 */
export const ModelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a filtered (or not, if using -1 parameter) list of models
         * @summary Models
         * @param {number} [modelType] 
         * @param {number} [poolId] 
         * @param {Array<string>} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModels: async (modelType?: number, poolId?: number, tag?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (modelType !== undefined) {
                localVarQueryParameter['model_type'] = modelType;
            }

            if (poolId !== undefined) {
                localVarQueryParameter['pool_id'] = poolId;
            }

            if (tag) {
                localVarQueryParameter['tag'] = tag;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all available tags list
         * @summary Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModelsApi - functional programming interface
 * @export
 */
export const ModelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModelsApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a filtered (or not, if using -1 parameter) list of models
         * @summary Models
         * @param {number} [modelType] 
         * @param {number} [poolId] 
         * @param {Array<string>} [tag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getModels(modelType?: number, poolId?: number, tag?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelsModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getModels(modelType, poolId, tag, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ModelsApi.getModels']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns all available tags list
         * @summary Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ModelsApi.getTags']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ModelsApi - factory interface
 * @export
 */
export const ModelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModelsApiFp(configuration)
    return {
        /**
         * Returns a filtered (or not, if using -1 parameter) list of models
         * @summary Models
         * @param {ModelsApiGetModelsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getModels(requestParameters: ModelsApiGetModelsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelsModel>> {
            return localVarFp.getModels(requestParameters.modelType, requestParameters.poolId, requestParameters.tag, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all available tags list
         * @summary Tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getTags(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModelsApi - interface
 * @export
 * @interface ModelsApi
 */
export interface ModelsApiInterface {
    /**
     * Returns a filtered (or not, if using -1 parameter) list of models
     * @summary Models
     * @param {number} [modelType] 
     * @param {number} [poolId] 
     * @param {Array<string>} [tag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsApiInterface
     */
    getModels(modelType?: number, poolId?: number, tag?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelsModel>>;

    /**
     * Returns all available tags list
     * @summary Tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsApiInterface
     */
    getTags(options?: RawAxiosRequestConfig): AxiosPromise<Array<string>>;

}

/**
 * Request parameters for getModels operation in ModelsApi.
 * @export
 * @interface ModelsApiGetModelsRequest
 */
export interface ModelsApiGetModelsRequest {
    /**
     * 
     * @type {number}
     * @memberof ModelsApiGetModels
     */
    readonly modelType?: number

    /**
     * 
     * @type {number}
     * @memberof ModelsApiGetModels
     */
    readonly poolId?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof ModelsApiGetModels
     */
    readonly tag?: Array<string>
}

/**
 * ModelsApi - object-oriented interface
 * @export
 * @class ModelsApi
 * @extends {BaseAPI}
 */
export class ModelsApi extends BaseAPI implements ModelsApiInterface {
    /**
     * Returns a filtered (or not, if using -1 parameter) list of models
     * @summary Models
     * @param {ModelsApiGetModelsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsApi
     */
    public getModels(requestParameters: ModelsApiGetModelsRequest = {}, options?: RawAxiosRequestConfig) {
        return ModelsApiFp(this.configuration).getModels(requestParameters.modelType, requestParameters.poolId, requestParameters.tag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all available tags list
     * @summary Tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModelsApi
     */
    public getTags(options?: RawAxiosRequestConfig) {
        return ModelsApiFp(this.configuration).getTags(options).then((request) => request(this.axios, this.basePath));
    }
}

